import { PersonalPropertyItem } from '../../generated/graphql';
import { FC, createContext, useContext } from 'react';

interface PersonalPropertyItemFormContextProps {
  householdID: string;
  children?: React.ReactNode;
  personalPropertyItem: PersonalPropertyItem | undefined | null;
}

interface PersonalPropertyItemFormContext extends Omit<PersonalPropertyItemFormContextProps, 'children'> {}

const PersonalPropertyItemFormContext = createContext<PersonalPropertyItemFormContext | null>(null);

export const usePersonalPropertyItemFormContext = () => {
  const context = useContext(PersonalPropertyItemFormContext);

  if (!context) {
    throw new Error('Make sure to use the PersonalPropertyItemFormContext inside of the provider');
  }
  return context;
};

export const PersonalPropertyItemFormContextProvider: FC<PersonalPropertyItemFormContextProps> = ({
  children,
  ...props
}) => {
  return <PersonalPropertyItemFormContext.Provider value={props}>{children}</PersonalPropertyItemFormContext.Provider>;
};
